<template>
  <div class="col-12 px-0 b-page b-page_height_auto">
    <div class="b-page__content">
      <main class="b-main__inner">
        <div v-if="!isReadOnlyMode" class="py-4 px-6 b-toolbar">
          <button
            class="b-btn b-btn_type_primary "
            @click="onClickCreatePayment()"
          >
            <dynamic-icon class="b-btn__icon b-btn__icon_color_white" icon="plus"/>
            {{ $t('CONTENT.payments.add_payment_name') }}
          </button>
        </div>
        <div class="b-table b-full-table b-full-table_type_short mx-6 mt-4 mb-10">
          <div class="b-table__row b-full-table__row b-full-table__row-header">
            <div
              class="b-table__cell b-full-table__cell b-full-table__header-cell b-table__cell_width_md"
            >{{ $t('CONTENT.payments.payment_name_creation') }}
            </div>
            <div
              class="b-table__cell b-full-table__cell b-full-table__header-cell b-table__cell_width_md"
            >{{ $t('CONTENT.payments.payment_type_creation') }}
            </div>
            <div
              class="b-table__cell b-full-table__cell b-full-table__header-cell b-table__cell_width_md"
            >{{ $t('CONTENT.payments.payment_kind_creation') }}
            </div>
          </div>
          <div
            class="b-table__row b-full-table__row"
            v-for="(item, index) in paymentNames"
            :key="index"
          >
            <div class="b-table__cell b-full-table__cell b-table__cell_width_md b-full-table__cell_type_flex">
              <button type="button" class="px-0 b-btn b-btn_type_empty b-btn__icon_color_main-text"
                      @click="editPayment(item)">
                <dynamic-icon v-if="!isReadOnlyMode" class="b-btn__icon" icon="edit"></dynamic-icon>
              </button>
              {{ item.name }}
            </div>
            <div class="b-table__cell b-full-table__cell b-table__cell_width_md">
              {{ $t('CONTENT.payments.' + item.paymentTypeCode) }}
            </div>
            <div class="b-table__cell b-full-table__cell b-table__cell_width_md"><span
              v-if="item.paymentKindCode !== null">{{ $t('CONTENT.payments.' + item.paymentKindCode) }}</span></div>
          </div>
        </div>
        <popup name="payment-popup" height="auto" :scrollable="true">
          <div data-cy="form-label" class="b-dialog__top-panel">
            <h2>{{ $t('CONTENT.payments.payment_create') }}</h2>
            <button class="b-btn b-btn_border_none" @click.prevent="closeEditDialog">
              <dynamic-icon icon="close"/>
            </button>
          </div>
          <CreatePayment
            v-if="isShowEditDialog"
            @closeDialog="closeEditDialog"
            :payment="paymentForForm"
          />
        </popup>
      </main>
    </div>
  </div>
</template>

<script>
import {mapGetters} from 'vuex';
import CreatePayment from "./edit/CreatePayment";

export default {
  components: {
    CreatePayment,
  },
  created() {
    this.role = localStorage.getItem('role');
    if (this.role === 'Admin') {
      this.isReadOnlyMode = false;
    }
  },
  data() {
    return {
      isReadOnlyMode: true,
      isShowEditDialog: false,
      paymentForForm: null,
    };
  },
  computed: {
    ...mapGetters(['getPaymentNames']),
    paymentNames() {
      return this.getPaymentNames;
    }
  },
  methods: {
    onClickCreatePayment() {
      // this.error = null;
      // this.currentDiscountRate = null;
      this.isShowEditDialog = true;
      this.$modal.show('payment-popup');
    },
    closeEditDialog() {
      this.isShowEditDialog = false;
      this.$modal.hide('payment-popup');
    },
    editPayment(item) {
      this.paymentForForm = item;
      this.isShowEditDialog = true;
      this.$modal.show('payment-popup');
    }
  }
};
</script>
